import { ready } from "@nephele/dom-utils";
import { ActionFormHelper } from "@nephele/form-utils";

ready(function () {
  const emailRegex = /\S+@\S+\.\S+/;
  const email = document.querySelector("#emailInput") as HTMLInputElement;
  const password = document.querySelector("#password") as HTMLInputElement;

  const maxPasswordLength = 128;
  const _actionFormHelper = new ActionFormHelper(
    document.querySelector("#actionForm")!,
    document.querySelector("#submitButton")!,
    document.querySelector("#loader")!,
    window.errors,
    [email, password],
    {
      failEarly: true,
      validators: [
        {
          input: email,
          error: window.errors.EmailFormatError!,
          validator: (value) => !value || !emailRegex.test(value),
        },
        {
          input: password,
          error: window.errors.PasswordEmpty!,
          validator: (value) => !value?.trim(),
          onError: () => {
            password.value = "";
          },
        },
        {
          input: password,
          error: window.errors.PasswordTooLong!,
          validator: (value) => value.length > maxPasswordLength,
        },
      ],
    },
  );
});
